import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 17109,
    label: 'tmw.administration.menu-title',
    icon: 'bi bi-gear-fill',
    subItems: [
      {
        id: 17152,
        label: 'tmw.edition.menu-title',
        link: '/backoffice/edition',
        parentId: 17109,
      },
      {
        id: 17151,
        label: 'Notifications',
        icon: 'bi bi-bell-fill',
        link: '/backoffice/notification-context',
        parentId: 17109,
      },
      {
        id: 17154,
        label: 'tmw.workflow.menu-title',
        link: '/backoffice/workflow',
        parentId: 17109,
      },
      {
        id: -616,
        label: 'tmw.annex-config.menu-title',
        icon: 'bi bi-bell-fill',
        link: '/backoffice/annexe-context',
        parentId: 17109,
      },
      {
        id: -1222,
        label: 'tmw.regle.menu-title',
        icon: 'bi bi-diagram-3',
        link: '/backoffice/regle',
        parentId: 17109,
      },
      {
        id: -1223,
        label: 'tmw.groupeRegle.menu-groupe-title',
        icon: 'bi bi-diagram-3',
        link: '/backoffice/groupe-regle',
        ressource: 'REGLE_GROUPE_VIEW',
        parentId: 17109,
      },
    ],
  },
  {
    id: 17111,
    label: 'tmw.referentiels.menu-title',
    icon: 'bi bi-database-fill-gear',
    subItems: [
      {
        id: 17155,
        label: 'tmw.referentiel.menu-title',
        link: '/backoffice/referentiel',
        parentId: 17111,
      },
      {
        id: 17156,
        label: 'tmw.requete.menu-title',
        link: '/backoffice/requete',
        parentId: 17111,
      },
    ],
  },
  {
    id: 17112,
    label: 'Gestion Utilisateurs',
    icon: 'bi bi-person-fill-gear',
    subItems: [
      {
        id: 17157,
        label: 'tmw.utilisateur.menu-title',
        link: '/backoffice/utilisateur',
        parentId: 17112,
      },
      {
        id: 17158,
        label: 'tmw.role.menu-title',
        link: '/backoffice/role',
        parentId: 17112,
      },
    ],
  },
];
